import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import VerifiedGuard from "../../components/auth/VerifiedGuard";
import { useTranslation } from "react-i18next";

type Props = {};

const UnAuthorized = (props: Props) => {
  const {t} = useTranslation();
  return (
    <AuthLayout>
      <VerifiedGuard>
        <main className="">
          <div className="row">
            <div className="col-md-6 mx-auto">
              <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                <div className="card-body p-sm-5 text-center">
                  <h2 className="fw-bolder mb-4" style={{ fontSize: "120px" }}>
                    4<span className="text-danger">0</span>1
                  </h2>
                  <h4 className="fw-bold mb-2">
                    {t("unAuthorized1")}
                  </h4>
                  <p className="fs-12 fw-medium text-muted">
                   {t("unAuthorized2")}
                  </p>
                  <div className="mt-5">
                    <a className="btn btn-light-brand w-100" href="/">
                      {t("unAuthorized3")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </VerifiedGuard>
    </AuthLayout>
  );
};

export default UnAuthorized;
